<template>
  <q-card flat bordered>
    <q-card-section class="q-pa-sm">
      <div class="text-subtitle2">후보 상품 목록</div>
    </q-card-section>
    <q-separator />
    <q-table
      :rows="candidates"
      :columns="columns"
      row-key="master_sku_id"
      flat
      dense
      :pagination="pagination"
      @row-click="onRowClick"
    >
      <template v-slot:body-cell-is_active="props">
        <q-td :props="props">
          <q-badge :color="props.value ? 'green' : 'grey'" outline>
            {{ props.value ? 'Active' : 'Inactive' }}
          </q-badge>
        </q-td>
      </template>
    </q-table>
  </q-card>
</template>

<script>
export default {
  name: 'CandidateList',
  props: {
    candidates: {
      type: Array,
      default: () => []
    }
  },
  emits: ['select'],
  data() {
    return {
      pagination: { rowsPerPage: 10 },
      columns: [
        { name: 'master_sku_code', label: '마스터 SKU', field: 'master_sku_code', align: 'left' },
        { name: 'display_name', label: '상품명', field: 'display_name', align: 'left' },
        { name: 'is_active', label: '상태', field: 'is_active', align: 'center' },
      ]
    }
  },
  methods: {
    onRowClick(_, row) {
      this.$emit('select', row.master_sku_id)
    }
  }
}
</script>
